export class VideoPlayConfig {
    playerPerfer: PlayerTech;
    shouldSkipFront: boolean;
    shouldSkipEnd: boolean
}


export enum PlayerTech {
    Original,
    Flash
}

export enum StreamTech {
    MP4,
    M3U8
}

export class VideoResource {

    public static secondFormat = '<span class="notranslate"><font>{second}s</font> 后播放广告</span>';
    public static vipskipFormat = '<font color="#FEC1A1">VIP已自动跳过广告</font >';
    public static memberskipFormat = '<font color="#FEC1A1">登陆会员已自动跳过广告</font >';
    public static vipskipFrontFormat = '<font color="#FEC1A1">VIP已自动跳过片头</font >';
    public static memberskipFrontFormat = '<font color="#FEC1A1">登陆会员已自动跳过片头</font >';
    public static skipFrontFormat = '<font color="#FEC1A1">已自动跳过片头</font >';
    public static vipskipEndFormat = '<font color="#FEC1A1">VIP用户5s后自动跳过片尾</font >';
    public static skipEndFormat = '<font color="#FEC1A1">5s后自动跳过片尾</font >';
    public static memberskipEndFormat = '<font color="#FEC1A1">登陆会员5s后自动跳过片尾</font >';
    public static boughtVideo = '金币<font color="#FFC000">-{0}</font >！ 已过滤广告！';
    public static alreadyBought = "您已经使用金币过滤广告。";
    public static alreadymax = "没有下一集了";
    public static viptoskip = '此功能仅限<font color="#FEC1A1">此功能仅限VIP使用</font >';
    public static membertoskip = '<font color="#EEC1A1">此功能仅限登录用户使用</font >';
    public static startup = "正在为您播放前置广告";
    public static notenoughGold = '<font color="#FEC1A1">金币不足，开通VIP可跳过广告</font >';
    // public static highFormat = "您是高等级用户，已为您过滤广告";
    public static highFormat = "已为您过滤广告";

}
